<template>
    <PopoverRight ref="popoverContent" width="700px">
       <div class="popover-slider-bar tag-lib-box">
          <p class="tag-lib-title">TDK动态取值标签库</p>
          <el-table :data="tagDataList" border style="width: 100%;" v-loading="isLoading">
            <el-table-column prop="name" label="适用范围"></el-table-column>
            <el-table-column prop="tag" label="标签名称">
                <template  slot-scope="scope">
                    <div class="tagArea"  @click="copyLib(scope.row.tag)">
                        <span>{{scope.row.tag}}</span>
                        <span class="copy">复制</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="rule" label="取值规则"></el-table-column>
            <el-table-column prop="example" label="取值示例"></el-table-column>
          </el-table>
          <template v-if="tagDataList.length > 0">
            <el-pagination
                background
                layout="total,prev, pager, next"
                :current-page="condition.page"
                :total="condition.total"
                :page-size="condition.per_page"
                @current-change="currentChange"
            ></el-pagination>
          </template>
          <div class="align-center bottom-box">
            <el-button @click="hideMenu">关闭</el-button>
          </div>
       </div>
    </PopoverRight>
</template>
<script>
import PopoverRight from '@/components/popoverRight/index'
import {getPageTdksRules} from '@/service/tdkManage'
export default {
    components:{
        PopoverRight
    },
    data(){
        return {
            condition: {
                per_page: 10,
                page: 1,
                total:0
            },
            tagDataList:[],
            isLoading:false,
        }
    },
    mounted(){
        this.initData();
    },
    methods:{
        openMenu(){
            this.$refs.popoverContent && this.$refs.popoverContent.open()
        },
        hideMenu(){
            this.$refs.popoverContent && this.$refs.popoverContent.hide()
        },
        tabClick(tab, event){
            this.condition.page = 1;
            this.initData();
        },
        async initData(){
            this.isLoading = true;
            getPageTdksRules(this.condition).then((data) => {
                this.condition.total=data.total
                this.tagDataList = data.data
            })
            this.isLoading = false
        },
        currentChange(index) {
            this.condition.page = index;
            this.initData();
        },
        copyLib(lib = "") {
            let oInput = document.createElement("input");
            oInput.value = lib;
            document.body.appendChild(oInput);
            oInput.select();
            document.execCommand("Copy");
            this.$message({
                message: "复制成功",
                type: "success",
            });
            oInput.remove();
        },
    }
}
</script>
<style lang="less" scoped>
 .tag-lib-box{
     height: 100%;
 }
 .tag-lib-title{
    margin-bottom: 15px;
    padding-bottom: 10px;
    font-size: 20px;
    color: #000;
    font-weight: bold;
 }
 .bottom-box{
     margin-top: 20px;
 }
 .tagArea{
     width: 100%;
     height: 100%;
 }
 .copy{
     color:#409EFF;
     margin-left:20px;
     cursor: pointer;
     display: none;
 }
 .tagArea:hover .copy{
     display: inline-block;
 }
</style>